import React, { useEffect, useState, useRef } from 'react';
import Layout from '@/common/Layout';
import { useNavigate } from 'react-router-dom';
import EditCantact from './components/MemberShipDetails';
// import { Form }from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import { paymentway, reset, verifyAPI } from './redux/slice';
import { get_byID } from '../EditDesiredPartnerDetails/redux/slice';
import { pageview } from '../../utilities/gtag';

const index = () => {
  useEffect(() => {
    document.title =
      'Choose membership plan - Premium Hindu matrimony services';
  }, []);
  useEffect(() => {
    pageview(location.pathname + location.search);
  }, [location]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // console.log('process.env', process.env);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // Clear Razorpay-related storage keys on page load
    localStorage.removeItem('razorpay_response');
    localStorage.removeItem('razorpayError');
    localStorage.removeItem('paymentCompleted');
    localStorage.removeItem('order_create');
    sessionStorage.removeItem('paymentInitiated');
    razorpayOpenedRef.current = false;

    dispatch(reset());
  }, []);

  const [selectedPlan, setSelectedPlan] = useState({
    title: '',
    price: '',
    billingFrequency: ''
  });

  const razorpayOpenedRef = useRef(false);

  // const [razorpayOpened, setRazorpayOpened] = useState(false);
  const paymentStatus = useSelector((state) => state.paymentgateway);
  const { paymentLoading } = useSelector((state) => state.paymentgateway);
  const { user_data } = useSelector((state) => state.listDashboard);

  console.log('selectedPlan', selectedPlan);
  // console.log('paymentLoading', paymentLoading);

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userId = matUserObject.user_details.id;

  function parsePrice(priceString) {
    // Regular expression to match currency and amount
    const regex = /^([A-Z]+)\s*([\d,]+(?:\.\d{1,2})?)$/;
    const match = priceString.match(regex);

    if (match) {
      const currency = match[1];
      const amount = parseFloat(match[2].replace(/,/g, ''));
      return { currency, amount };
    } else {
      throw new Error('Price string is in an unrecognized format.');
    }
  }

  // const get_listby_id = () => {
  //   const payload = userId;
  //   dispatch(get_byID(payload));
  // };

  const getUserDetails = () => {
    if (userId) dispatch(get_byID(userId));
  };

  useEffect(() => {
    // Check if the page has been reloaded already
    const hasReloaded = sessionStorage.getItem('hasReloaded');

    if (!hasReloaded) {
      sessionStorage.setItem('hasReloaded', 'true');
      // window.location.reload(); // Force reload the page
      getUserDetails();
    } else {
      sessionStorage.removeItem('hasReloaded'); // Clear flag after reload
    }
  }, []);

  // useEffect(() => {
  //   get_listby_id();
  // }, []);

  useEffect(() => {
    if (
      selectedPlan.price &&
      selectedPlan.title &&
      selectedPlan.billingFrequency
    ) {
      try {
        localStorage.removeItem('razorpayError');
        const { currency, amount } = parsePrice(selectedPlan.price);

        // const matUserData = localStorage.getItem('MAT-User');
        // const matUserObject = JSON.parse(matUserData);
        const email = matUserObject.user_details.email || '';
        const customerName =
          matUserObject.user_details.first_name +
          ' ' +
          matUserObject.user_details.last_name;

        const payload = {
          trn: crypto.randomUUID(),
          amount: amount,
          currency: currency,
          notes: {
            productName: selectedPlan.title,
            planType: selectedPlan.billingFrequency,
            customerName: customerName,
            customerEmail: email
          }
        };

        localStorage.setItem('order_create', JSON.stringify(payload));
        sessionStorage.setItem('paymentInitiated', 'true');

        localStorage.removeItem('razorpayError');
        localStorage.removeItem('paymentCompleted');

        // setRazorpayOpened(false);
        razorpayOpenedRef.current = false;
        dispatch(paymentway(payload));
        console.log('price_data', payload);
      } catch (error) {
        // console.error(error.message);
        console.error('Payment payload error:', error.message);
      }
    }
  }, [selectedPlan]);

  useEffect(() => {
    loadRazorpayScript();
  }, []);
  // useEffect(() => {
  //   razorpayOpenedRef.current = false;
  // }, []);

  // This effect runs when payment status changes
  useEffect(() => {
    const paymentInitiated = sessionStorage.getItem('paymentInitiated');
    const razorpayError = localStorage.getItem('razorpayError');
    const paymentCompleted = localStorage.getItem('paymentCompleted');

    if (!paymentStatus?.isFetched || !paymentInitiated) return;
    console.log('Payment status changed:', paymentStatus);

    console.log('paymentStatus.success:', paymentStatus.success);
    console.log(
      'paymentStatus.payment_details:',
      paymentStatus.payment_details
    );
    console.log('razorpayOpenedRef.current:', razorpayOpenedRef.current);
    console.log('razorpayError:', razorpayError);
    console.log('paymentCompleted:', paymentCompleted);

    const canTriggerRazorpay =
      paymentStatus.success &&
      paymentStatus.payment_details &&
      !razorpayOpenedRef.current &&
      !razorpayError &&
      !paymentCompleted;
    console.log('canTriggerRazorpay', canTriggerRazorpay);
    if (canTriggerRazorpay) {
      console.log('Successful payment status detected');
      // Open Razorpay when we have a successful order response
      razorpayOpenedRef.current = true;
      // setRazorpayOpened(true);
      setLoading(true);
      openRazorpayCheckout();
    }

    if (paymentStatus.success === false && !razorpayError) {
      setLoading(false);
      localStorage.setItem('razorpayError', 'true');
      sessionStorage.removeItem('paymentInitiated');
      dispatch(reset());
      navigate('/failure');
    }

    if (paymentStatus?.payment_details?.amount) {
      localStorage.setItem(
        'payment_Amount_GST',
        paymentStatus.payment_details.amount
      );
    }

    // localStorage.setItem(
    //   'payment_Amount_GST',
    //   paymentStatus?.payment_details?.amount
    // );
  }, [paymentStatus]);

  const openRazorpayCheckout = async () => {
    try {
      // setLoading(true);
      console.log('Opening Razorpay checkout...');
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        // alert('Razorpay SDK failed to load. Check your internet connection.');
        console.error('Razorpay SDK failed to load.');
        localStorage.setItem('razorpayError', 'true');
        // setLoading(false);
        dispatch(reset());
        navigate('/failure');
        return;
      }

      console.log('Script loaded successfully');

      const orderDetails = paymentStatus.payment_details;
      console.log('Order details for Razorpay:', orderDetails);
      console.log('Order paymentStatus:', paymentStatus);
      console.log('Order details for Razorpay:', orderDetails);
      console.log('payment_id:', paymentStatus?.payment_id);
      localStorage.setItem('payment_details', paymentStatus?.payment_id);
      // Setup Razorpay options
      const options = {
        // key: 'rzp_test_8oey15fzuX4stX',
        // key: 'rzp_live_L0qRl6FSDIsTyl',
        key: process.env?.REACT_APP_RAZORPAY_KEY_ID,
        amount: orderDetails.amount,
        currency: orderDetails.currency,
        name: 'Your Company Name',
        description: `Payment for ${orderDetails.notes.productName}`,
        order_id: orderDetails.id, // This is the Razorpay order ID
        handler: async function (response) {
          console.log('Payment successful', response);
          // Handle successful payment
          const resultAction = await dispatch(verifyAPI(response));
          if (verifyAPI.fulfilled.match(resultAction)) {
            console.log('Payment successful', response);
            localStorage.setItem('razorpay_response', JSON.stringify(response));
            localStorage.setItem('paymentCompleted', 'true');
            localStorage.removeItem('razorpayError');
            // You should verify the payment on your backend here
            navigate('/success');
          } else {
            console.error('Payment verification failed', resultAction.payload);
            // resetPaymentState();
            localStorage.setItem('razorpayError', 'true');
            navigate('/failure'); // Navigate to failure page
          }
        },
        prefill: {
          name: orderDetails.notes.customerName,
          email: orderDetails.notes.customerEmail
        },
        theme: {
          color: '#3399cc'
        },
        modal: {
          ondismiss: function () {
            console.log('Modal dismissed');
            // setLoading(false);
            // localStorage.removeItem('paymentCompleted');
            localStorage.setItem('razorpayError', 'true');
            // dispatch(paymentway.reset());
            localStorage.removeItem('razorpay_response');
            localStorage.removeItem('paymentCompleted');
            // localStorage.removeItem('order_create');
            localStorage.removeItem('razorpayError');
            dispatch(reset());
            // resetPaymentState();
            navigate('/failure'); // Redirect on failure or dismissal
          }
        }
      };
      console.log('Razorpay options:', options);
      // Initialize and open Razorpay
      const razorpay = new window.Razorpay(options);
      razorpay.open();
      console.log('Razorpay modal opened');
    } catch (error) {
      console.error('Error during Razorpay checkout:', error);
      localStorage.setItem('razorpayError', 'true');
      // alert('Something went wrong. Please try again later.');
      setLoading(false);
      // resetPaymentState();
    }
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    return () => {
      console.log('Clearing payment data on unmount');
      localStorage.removeItem('razorpay_response');
      localStorage.removeItem('paymentCompleted');
      // localStorage.removeItem('order_create');
      localStorage.removeItem('razorpayError');
      // dispatch(paymentway.reset());
      dispatch(reset());
      setLoading(false);
      razorpayOpenedRef.current = false;
      // setRazorpayOpened(false);
    };
  }, [dispatch]);

  return (
    <>
      <Layout sider={true}>
        <EditCantact
          onsubmit={onsubmit}
          setSelectedPlan={setSelectedPlan}
          selectedPlan={selectedPlan}
          loading={loading}
          user_data={user_data}
          paymentLoading={paymentLoading}
        />
      </Layout>
    </>
  );
};

export default index;
